/* eslint-disable prefer-destructuring */
/* eslint-disable no-prototype-builtins */
/* eslint-disable prefer-promise-reject-errors */
// import { useAuth } from '../context/auth/auth-context';
import axios from 'axios';
import { logout } from '../containers/App/actions';
import { logout as clearUser } from '../containers/LoginPage/actions';

const UI_APP_SERVER_URL = process.env.UI_APP_SERVER_URL;
const API_URL = UI_APP_SERVER_URL || '/api';
let store = null;

function initStore(newStore) {
  store = newStore;
}
class API {
  constructor() {
    this.createAxiosInstance();
  }

  createAxiosInstance() {
    const config = {
      baseURL: API_URL,
    };

    this.axiosInstance = axios.create(config);

    this.axiosInstance.interceptors.response.use(
      (response) => {
        if (response.headers.hasOwnProperty('content-disposition')) {
          return response;
        }

        return { response: { ...response.data } };
      },
      (error) => {
        if (error.response.status === 401) {
          if (store != null) {
            store.dispatch(logout());
            store.dispatch(clearUser());
          }
        }

        if (error.response.status === 502) {
          return Promise.reject({ error: { message: 'Server offline!' } });
        }
        if (error.response.status === 503) {
          return Promise.reject({
            error: error.response.statusText,
            response: error?.response?.data,
          });
        }
        if (error.response.status === 504) {
          return Promise.reject({ error: { message: 'Error' } });
        }
        if (error.response.status === 413) {
          return Promise.reject({
            error: { code: 413, message: 'Error too large' },
          });
        }
        if (error.response.status === 415) {
          return Promise.reject({
            error: {
              code: 415,
              message: 'Error contentTypeReq != contentType',
            },
          });
        }

        return Promise.reject({ error: { ...error.response.data } });
      }
    );
  }

  get authAxios() {
    if (!this.authAxiosInstance || !this.axiosInstance) {
      this.createAxiosInstance();
    }
    return this.authAxiosInstance ? this.authAxiosInstance : this.axiosInstance;
  }

  get axios() {
    if (!this.axiosInstance) {
      this.createAxiosInstance();
    }

    return this.axiosInstance;
  }
}

// function postCallAsync(url, data, options) {
//   return new API(url).axios.post(url, data, options);
// }

function postCall(url, data, options) {
  return new API(url).axios
    .post(url, data, options)
    .then((response) => response)
    .catch((error) => error);
}

function getCallSync(url) {
  return new API().axios.get(url).then((response) => response);
  // .catch(error => error);
}

function getCall(url, data, options) {
  return new API().axios
    .get(url, data, options)
    .then((response) => ({ response }))
    .catch((error) => ({ error }));
}

const APIClient = new API();
export { getCallSync, postCall, getCall, initStore };
export default APIClient;
